import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    // Cookie is already set by the server — just verify by fetching the user
    API.get("/auth/me").then(r => {
      setUser(r.data);
      navigate("/", { replace: true });
    }).catch(() => navigate("/login", { replace: true }));
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <div className="spinner" />
    </div>
  );
}
